import { geometry } from 'app/contracts/Geometry';
import { particles } from 'app/contracts/Particles';
import { ParticleBehaviourTagType, LookupType } from 'app/enum/Particles';
import { ParticleBehaviour } from '../ParticleBehaviour';
import { Inertia } from 'utils/motion/Inertia';

export class ParticlePath extends ParticleBehaviour {
	protected _tags: Array<ParticleBehaviourTagType> = [ParticleBehaviourTagType.PATH];

	public syncRotation = false;
	public scaleAffect = true;

	private _xMuliplier: number = 1;
	private _yMuliplier: number = 1;
	private _expandMuliplier: Inertia;
	private _speedMulipler: Inertia;
	private _speed: number = 1;
	private _direction: number = 1;
	private _path: particles.ParticleLookup;
	private _pathIndex: number;
	private _roundedPathIndex: number;
	private _scaleRange: geometry.Range;
	private _scaleIndex: number;
	private _scaleActive: boolean = false;
	private _alphaActive: boolean = false;

	constructor(
		sceneProps: particles.ParticlesSceneProps,
		particleProps: particles.ParticleProps,
		animatedProps: particles.ParticleProperties
	) {
		super(sceneProps, particleProps, animatedProps);
		this._expandMuliplier = new Inertia(5, 1);
		this._speedMulipler = new Inertia(5, 1);
	}

	//GETTER / SETTER
	//--------------------------------------------------------------------------------------------------
	public set path(type: LookupType) {

		if (type) {
			this._path = this._sceneProps.lookups[type];
		} else {
			this._path = null;
		}
	}

	public set xMuliplier(x: number) {
		this._xMuliplier = x;
	}

	public set yMuliplier(y: number) {
		this._yMuliplier = y;
	}

	public get xMuliplier(): number {
		return this._xMuliplier;
	}

	public get yMuliplier(): number {
		return this._yMuliplier;
	}

	public set expandMuliplier(target: number) {
		this._expandMuliplier.target = target;
	}
	public get expandMuliplier(): number {
		return this._expandMuliplier.target;
	}

	public set speedMuiliplier(target: number) {
		this._speedMulipler.target = target;
	}

	public get speed(): number {
		return this._speed;
	}

	public set pathIndex(index: number) {
		this._pathIndex = index;
	}

	public set speed(speed: number) {
		this._speed = speed;
	}

	public set direction(direction: number) {
		this._direction = direction;
	}

	public set scaleActive(active: boolean) {
		this._scaleActive = active;
	}

	public set scaleRange(range: geometry.Range) {
		this._scaleRange = range;
	}

	public set alphaRange(range: geometry.Range) {
	}

	public set alphaActive(active: boolean) {
		this._alphaActive = active;
	}

	//PUBLIC METHODS
	//-----------------------------------------------------------------------------------------

	public tick() {
		this._processPosition();

		if (this._scaleActive) {
			this._processScale();
		}

		this._expandMuliplier.tick();
		this._speedMulipler.tick();
	}

	public hardPositionUpdate(): void {
		this._roundedPathIndex = Math.floor(this._pathIndex);
		this._animatedProps.x = this._animatedProps.targetX =
			this._particleProps.ref.position.absX +
			this._path.table[this._roundedPathIndex].x * (this._xMuliplier * this._expandMuliplier.value);
		this._animatedProps.y = this._animatedProps.targetY =
			this._particleProps.ref.position.absY +
			this._path.table[this._roundedPathIndex].y * (this._yMuliplier * this._expandMuliplier.value);
	}

	/** Randomise the positions along the paths */
	public randomise(unsyncedScaleIndex: boolean = false, direction: boolean = false): void {
		this._pathIndex = this._scaleIndex = Math.random() * (this._path.table.length - 1);

		if (unsyncedScaleIndex) {
			this._scaleIndex = Math.random() * (this._path.table.length - 1);
		}

		if (direction) {
			this._direction = Math.random() < 0.5 ? -1 : 1;
		}
	}

	//PRIVATE METHODS
	//-----------------------------------------------------------------------------------------
	private _processPosition(): void {
		this._pathIndex += this._direction * this._speed * this._speedMulipler.value * (window as any).deltaTime;

		if (this._pathIndex >= this._path.table.length) {
			this._pathIndex = 0;
		} else if (this._pathIndex <= 0) {
			this._pathIndex = this._path.table.length - 1;
		}

		this._roundedPathIndex = Math.floor(this._pathIndex);


		let s = this.scaleAffect ? this._sceneProps.zones.spaces.scale : 1;
		this._animatedProps.increaseTargetX(
			this._path.table[this._roundedPathIndex].x * (this._xMuliplier * this._expandMuliplier.value) * s
		);
		this._animatedProps.increaseTargetY(
			this._path.table[this._roundedPathIndex].y * (this._yMuliplier * this._expandMuliplier.value) * s
		);

		if (this.syncRotation) {
			let degrees = Math.round((360 / this._path.table.length) * this._pathIndex);

			if (this._direction == 1) {
				degrees += 180;
			}

			const rotation = degrees * (Math.PI / 180);
			if (this._particleProps.sprite.rotation != rotation) {
				this._particleProps.sprite.rotation = rotation;
			}
		}

	}

	private _processScale(): void {
		this._scaleIndex += this._direction * this._speed;

		if (this._scaleIndex >= this._path.table.length) {
			this._scaleIndex = 0;
		} else if (this._scaleIndex <= 0) {
			this._scaleIndex = this._path.table.length - 1;
		}

		this._animatedProps.targetScale =
			this._scaleRange.min +
			(this._scaleRange.max - this._scaleRange.min) * this._path.table[Math.floor(this._scaleIndex)].scale;

		if (this._alphaActive) {
		}
	}
}
